<template>
  <div class="h-toolbarBg">
  <ejs-toolbar>
    <e-items>
      <e-item v-if='btns.add' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("PDN.add")' :click='buttonClick' eventType='add'></e-item>
      <e-item v-if='btns.mod' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("PDN.modify")' :click='buttonClick' eventType='mod'></e-item>
      <e-item v-if='btns.del' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("PDN.remove")' :click='buttonClick' eventType='del'></e-item>
      <e-item v-if='btns.qry' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("PDN.refresh")' :click='buttonClick' eventType='qry'></e-item>
   </e-items>
  </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'DNNProfileTableMenu',
  data() {
    return {
      btns: {
        add: true,
        mod: true,
        del: true,
        qry: true
      },
    };
  },
  methods: {
    buttonClick(args) {
      this.$emit('methodEnum', args.item.eventType);
    },
  }
};
</script>

<style scoped>

</style>
